import { Heading, StackProps, VStack } from "@biblioteksentralen/react";
import { ReactNode } from "react";
import InternalLink from "../InternalLink";

type CampaignViewSectionProps = {
  children: ReactNode;
  headline?: string;
  headingSize?: "h2" | "h3";
  href?: string;
} & StackProps;

export const CampaignViewSection = ({
  children,
  headline,
  href,
  headingSize = "h2",
  ...stackProps
}: CampaignViewSectionProps) => (
  <VStack
    as={headline ? "section" : "div"}
    width="100%"
    gap="1rem"
    position="relative"
    alignItems="flex-start"
    padding={{ base: "0 1rem", sm: "0 2rem" }}
    {...stackProps}
  >
    {headline && (
      <Heading as={headingSize} fontSize={{ base: "xl", md: "2xl" }}>
        {href ? (
          <InternalLink href={href} variant="plain">
            {headline}
          </InternalLink>
        ) : (
          <>{headline}</>
        )}
      </Heading>
    )}
    {children}
  </VStack>
);
